import { createContext, useContext, useEffect, useState } from "react";
import api, { API } from "../lib/api";
import { DEFAULT_SETTINGS, IMAGES } from "../constants/content";

const SiteContext = createContext({ ...DEFAULT_SETTINGS, images: IMAGES });

export function SiteProvider({ children }) {
  const [settings, setSettings] = useState({ ...DEFAULT_SETTINGS, images: IMAGES });
  useEffect(() => {
    api.get("/settings").then((r) => {
      const overrides = {};
      Object.entries(r.data.images || {}).forEach(([k, v]) => {
        overrides[k] = `${API}/site-image/${k}?v=${encodeURIComponent(v || "1")}`;
      });
      setSettings({ ...DEFAULT_SETTINGS, ...r.data, images: { ...IMAGES, ...overrides }, customImages: Object.keys(r.data.images || {}) });
    }).catch(() => {});
  }, []);
  return <SiteContext.Provider value={settings}>{children}</SiteContext.Provider>;
}

export const useSite = () => useContext(SiteContext);

export const phoneDisplay = (phone) => {
  if (!phone) return "";
  const d = phone.replace(/\D/g, "");
  if (d.startsWith("64") && d.length >= 11 && d.length <= 12) return `+64 ${d.slice(2, 4)} ${d.slice(4, 7)} ${d.slice(7)}`;
  return phone;
};
